export default "__VITE_ASSET__Bvh96BnW__"